<template>
  <main-layout
    controlsBg="light"
    :hasControlsBar="false"
    :breadcrumb="getBreadcrumb">
    <div class="container">
      <grid-row column-align="center">
        <grid-col col-size="4">
          <h1 class="header margin-top-xl marg">
            <chevron @click="$router.push({name: 'Settings'})"/>
            {{ $t('permissionAssignment.title') }}
          </h1>
          <alert
            v-if="alertVisible"
            :message="alertMessage"
            :type="alertType">
          </alert>
        </grid-col>
      </grid-row>
      <grid-row column-align="center">
        <grid-col col-size="4">
          <div class="flex">
            <v-select class="v-select--light"
                      :value="selectedUser" :onChange="changeUser" :searchable="true" :options="getUserSelectOptions"></v-select>
            <BtnPill :btnText="$t('commons.save')"
                     btn-size="s"
                     :disabled="!selectedUser"
            v-on:click="updateReadableUsers">
            </BtnPill>
            </div>
          <table-component
            :data="fetchData"
            sort-by="email"
            sort-order="asc"
            ref="userTable"
            class="margin-top-m"
          >
            <table-column show="id" label="Id" :hidden="true"></table-column>
            <table-column show="name" :label="$t('variables.name')"></table-column>
            <table-column show="email" label="Email"></table-column>
            <table-column label="" :sortable="false" :filterable="false">
              <template slot-scope="row">
                <checkbox v-on:change="changeSelected($event, row.id)"
                          :checked="hasPermissions(row.id)"
                          :id="String(row.id)"
                          check-size="m"/>
              </template>
            </table-column>
          </table-component>

        </grid-col>
      </grid-row>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import Chevron from '@/components/shared/Chevron';
import Checkbox from '@/components/shared/forms/Checkbox';
import BtnPill from '@/components/shared/buttons/BtnPill';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import pagination from '@/components/shared/table/pagination';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import vSelect from 'vue-select';
import apiPermission from '@/api/permissionAssignment';
import Alert from '@/components/shared/alert/Alert';

export default {
  name: 'PermissionAssignment',
  components: {
    MainLayout,
    Chevron,
    vSelect,
    Checkbox,
    BtnPill,
    GridCol,
    GridRow,
    Alert,
    TableComponent,
    TableColumn
  },
  data () {
    return {
      alertVisible: false,
      alertMessage: '',
      alertType: '',
      users: [],
      selectorUsers: [],
      selectedUser: null,
      readableUsers: [],
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      }
    };
  },
  watch: {
    filteredUsers: {
      handler: function () {
        this.$refs.userTable.refresh();
      }
    }
  },
  mounted () {
    apiPermission.getSelectionableAndAssignableUsers(this).then((data) => {
      this.users = data.assignableUsers;
      this.selectorUsers = data.selectionableUsers;
    });
    const alert = this.$route.params.alert;
    if (alert !== undefined) {
      showAlert(this, this.$t(alert), 'success');
    }
  },
  computed: {
    getBreadcrumb () {
      return [
        {
          name: this.$t('permissionAssignment.title'),
          disabled: true
        }
      ];
    },
    getUserSelectOptions () {
      return this.selectorUsers.map((user) => {
        return {
          label: user.name,
          value: user.id
        };
      });
    },
    getUsers () {
      return this.users;
    },
    filteredUsers () {
      return this.selectedUser ? this.users.filter(user => user.id !== this.selectedUser.value) : [];
    }
  },
  methods: {
    changeUser (user) {
      this.selectedUser = user;
      if (user != null) {
        apiPermission.getReadableUsers(this, Number(user.value)).then((data) => {
          this.readableUsers = data.body;
        });
      }
    },
    hasPermissions (id) {
      return this.readableUsers.includes(id);
    },
    changeSelected (isChecked, userId) {
      if (isChecked) {
        this.readableUsers.push(userId);
      } else {
        this.readableUsers = this.readableUsers.filter(id => id !== userId);
      }
    },
    updateReadableUsers () {
      if (this.selectedUser) {
        apiPermission.updateReadableUsers(this, Number(this.selectedUser.value), this.readableUsers)
          .then(() => showAlert(this, this.$t('permissionAssignment.save.success', {name: this.selectedUser.label}), 'success'))
          .catch((error) => showAlert(this, error.data.message, 'error'));
      } else {
        showAlert(this, this.$t('permissionAssignment.save.error'), 'error');
      }
    },
    fetchData ({ page, filter, sort }) {
      const tablePage = pagination.createPage(
        this.filteredUsers,
        this.tableState,
        ['name', 'email'],
        this.tablePageSize,
        { page, filter, sort });
      this.tableState = tablePage.state;
      return tablePage.result;
    }
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2500);
};

</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

.users-box {
  max-height: $height5 * 10;
  width: fit-content;
}

.users-box ::-webkit-scrollbar {
  width: 10px;
}

.users-box ::-webkit-scrollbar-track {
  background: white;
}

.users-box ::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: #2c62ba
}

</style>



// WEBPACK FOOTER //
// src/layouts/PermissionAssignment.vue